<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link" @click="toProductCatalogPage">&nbsp;Product</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Detail ID {{ productId }}</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <h5 class="card-title">Log Action</h5>
                                <div class="card" style="border: none;">
                                  <div class="card-body" style="padding: 0px;">
                                    <table class="fixed_header table-bordered table-striped">
                                      <tbody class="full-width">
                                        <tr>
                                          <th style="min-width: 150px;">When</th>
                                          <th style="min-width: 500px;">What</th>
                                          <th>Who</th>
                                        </tr>
                                        <tr v-if="dataLog.length == 0">
                                          <td colspan="3">Tidak ada Log</td>
                                        </tr>
                                        <tr v-else v-for="(data, index) in dataLog" :key="`log-${index}`">
                                          <td> {{ data.time }}</td>
                                          <td> {{ data.text }}</td>
                                          <td> {{ data.ids }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="one-line">
                                            <label class="ol-label"> Product </label>
                                            <label class="ol-titik2">:</label>
                                            <multiselect v-model="addType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" deselect-label="Can't remove this value" placeholder="Product Type" track-by="productTypeName"></multiselect>
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label" v-if="addType.productType < 7"> Category </label>
                                            <label class="ol-titik2" v-if="addType.productType < 7">:</label>
                                            <multiselect v-model="addCategory" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" deselect-label="Can't remove this value" placeholder="Product Category" track-by="productCategory" v-if="addType.productType < 7"></multiselect>
                                        </div>
                                        <div class="one-line" v-if="addCategory.productCategory == 'Other'">
                                            <label class="ol-label"> New Category </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" class="form-control" name="" v-model="newCategory">
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label"> Brand </label>
                                            <label class="ol-titik2">:</label>
                                            <multiselect v-model="addBrand" :options="productBrand" :allow-empty="false" :select-label="'Brand'" deselect-label="Can't remove this value" placeholder="Product Brand"></multiselect>
                                        </div>
                                        <div class="one-line" v-if="addBrand == 'Other'">
                                            <label class="ol-label"> New Brand </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="product" class="form-control" v-model="newBrand">
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label"> Model </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="model" class="form-control" v-model="addModel">
                                        </div>
                                        <div style="display: inline;">
                                            <div class="one-line" v-if="this.addType.productType == '1' || this.addType.productType == '2'||this.addType.productType == '5'||this.addType.productType == '6'">
                                                <label class="ol-label"> Screen </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="screen" class="form-control" v-model="addScreen" @keypress="isNumber($event)">
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '1' ||this.addType.productType == '2'||this.addType.productType == '5'||this.addType.productType == '6'">
                                                <label class="ol-label"> Processor </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="processor" class="form-control" v-model="addProcessor">
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '1' ||this.addType.productType == '2'||this.addType.productType == '5'||this.addType.productType == '6'">
                                                <label class="ol-label"> RAM (GB) </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="ram" class="form-control" v-model="addRam" @keypress="isNumber($event)">
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '5' ||this.addType.productType == '6'">
                                                <label class="ol-label"> Storage (GB)</label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="storage" class="form-control" v-model="addStorageSmartphone[0]" @keypress="isNumber($event)">
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '1'||this.addType.productType == '2'">
                                                <label class="ol-label storage"> Storage <span v-if="storageType == 'HDD+SSD'">(HDD)</span></label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="storage" class="form-control" v-model="addStorage[0]" @keypress="isNumber($event)">
                                                <select class="form-control storage-type ml-2" name="storage_type" v-model="storageType">
                                                    <option value="SSD">SSD</option>
                                                    <option value="HDD">HDD</option>
                                                    <option value="HDD+SSD">HDD+SSD</option>
                                                </select>
                                            </div>
                                            <div class="one-line" v-if="(this.addType.productType == '1' ||this.addType.productType == '2') && storageType == 'HDD+SSD'">
                                            <label class="ol-label storage"> Storage (SSD)</label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="storage" class="form-control" v-model="addStorage[1]" @keypress="isNumber($event)">
                                            <span style="width: 147px;"></span>
                                        </div>
                                        <div class="one-line" v-if="this.addType.productType == '5'||this.addType.productType == '6'">
                                            <label class="ol-label"> Main Camera </label>
                                            <label class="ol-titik2">:</label>
                                            <textarea rows="3" type="text" name="mainCamera" class="form-control" v-model="mainCamera" style="resize: none"></textarea>
                                        </div>

                                        <div class="one-line" v-if="this.addType.productType == '5'||this.addType.productType == '6'">
                                            <label class="ol-label"> Front Camera </label>
                                            <label class="ol-titik2">:</label>
                                            <textarea rows="3" type="text" name="frontCamera" class="form-control" v-model="frontCamera" style="resize: none"></textarea>
                                        </div>

                                        <div class="one-line" v-if="this.addType.productType == '5'||this.addType.productType == '6'">
                                            <label class="ol-label"> Battery (mAh)</label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="battery" class="form-control" v-model="addBattery" @keypress="isNumber($event)">
                                        </div>
                                            <div class="one-line" v-if="this.addType.productType == '1'||this.addType.productType == '2'">
                                                <label class="ol-label"> VGA </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="vga" class="form-control" v-model="addVGA">
                                            </div>
                                        </div>
                                        <div style="display: inline;">
                                            <div class="one-line" v-if="this.addType.productType == '3'">
                                                <label class="ol-label"> Display Size </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="displaysize" class="form-control" v-model="addDisplaySize" @keypress="isNumber($event)">
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '3'">
                                                <label class="ol-label"> Display Type </label>
                                                <label class="ol-titik2">:</label>
                                                <multiselect v-model="addDisplayType" :options="productDisplayType" :allow-empty="false" :select-label="'Display Type'" deselect-label="Can't remove this value" placeholder="Display Type"></multiselect>
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '3'">
                                                <label class="ol-label"> Port VGA </label>
                                                <label class="ol-titik2">:</label>
                                                <multiselect v-model="addPortVga" :options="productVGA" :allow-empty="false" :select-label="'VGA'" deselect-label="Can't remove this value" placeholder="Port VGA"></multiselect>
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '3'">
                                                <label class="ol-label"> Port DVI-D </label>
                                                <label class="ol-titik2">:</label>
                                                <multiselect v-model="addPortDvid" :options="productDVID" :allow-empty="false" :select-label="'DVI-D'" deselect-label="Can't remove this value" placeholder="Port DVI-D"></multiselect>
                                            </div>
                                            <div class="one-line" v-if="this.addType.productType == '3'">
                                                <label class="ol-label"> Port HDMI </label>
                                                <label class="ol-titik2">:</label>
                                                <multiselect v-model="addPortHdmi" :options="productHDMI" :allow-empty="false" :select-label="'HDMI'" deselect-label="Can't remove this value" placeholder="Port HDMI"></multiselect>
                                            </div>
                                        </div>
                                        <div class="one-line" v-if="this.addType.productType == '4'">
                                            <label class="ol-label"> Color Technology </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="colorTech" class="form-control" v-model="addColorTech">
                                        </div>
                                        <div class="one-line" v-if="this.addType.productType == '4'||this.addType.productType == '5'||this.addType.productType == '6'">
                                            <label class="ol-label"> Feature </label>
                                            <label class="ol-titik2">:</label>
                                            <textarea type="text" name="feature" class="form-control" v-model="AddFeature" rows="3" style="resize: none;"></textarea>
                                        </div>

                                        <div class="one-line" v-if="this.addType.productType > '6'">
                                            <label class="ol-label"> Specifications </label>
                                            <label class="ol-titik2">:</label>
                                            <textarea class="form-control form-control-sm" rows="5" v-model="addSpecifications"></textarea>
                                        </div>

                                        <div class="one-line">
                                            <label class="ol-label"> Description </label>
                                            <label class="ol-titik2">:</label>
                                            <textarea class="form-control form-control-sm" rows="5" id="description" v-model="addDescription"></textarea>
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label"> Sum Insured </label>
                                            <label class="ol-titik2">:</label>
                                            <div class="input-group">
                                                <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                <input type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model="addSumInsured">
                                            </div>
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label"> Year </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="colorTech" class="form-control" v-model="addYear">
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label-photo"> Photo </label>
                                            <label class="ol-titik2">:</label>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[0]" class="img-responsive" id="show_img_1">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_1" @change="onFilePicked($event,1)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(1)">Remove</button>
                                                </div>
                                            </div>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[1]" class="img-responsive" id="show_img_2">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_2" @change="onFilePicked($event,2)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(2)">Remove</button>
                                                </div>
                                            </div>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[2]" class="img-responsive" id="show_img_3">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_3" @change="onFilePicked($event,3)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(3)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="one-line">
                                            <label class="ol-label-photo"> </label>
                                            <label class="ol-titik2"></label>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[3]" class="img-responsive" id="show_img_4">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_4" @change="onFilePicked($event,4)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(4)">Remove</button>
                                                </div>
                                            </div>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[4]" class="img-responsive" id="show_img_5">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_5" @change="onFilePicked($event,5)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(5)">Remove</button>
                                                </div>
                                            </div>
                                            <div class="one-file text-center">
                                                <img :src="urlPhoto[5]" class="img-responsive" id="show_img_6">
                                                <div class="one-line-file">
                                                    <input type="file" name="" class="form-control-file form-control-sm" id="file_img_6" @change="onFilePicked($event,6)">
                                                    <button class="btn btn-danger btn-sm mr-2 mt-2" @click="removeImage(6)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="one-line mt-3">
                                            <label class="ol-label-dur"> Duration (Month) </label>
                                            <label class="ol-titik2">:</label>
                                            <multiselect v-model="addDuration[0]" :options="productDuration[0]" label="tenorMonths" :allow-empty="false" :select-label="'Month'" deselect-label="" placeholder="Duration" class="duration" track-by="tenorMonths" @input="updateDuration('duration',0)"></multiselect>
                                            <div class="input-group">
                                                <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                <input type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model="durationPrice[0]" v-if="addDuration[0].tenorMonths != 'Other'">
                                                <input type="text" class="form-control price" name="price" @keypress="isNumber($event)" disabled="" v-model="durationPrice[0]" v-else>
                                                <label class="permonth">/month</label>
                                                <button type="button" class="btn btn-primary btn-icon btn-plus ml-2" @click="addRow(plusIdx)">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="one-line mt-3" v-if="addDuration[0].tenorMonths == 'Other'">
                                            <label class="ol-label-dur-new"> New Duration </label>
                                            <label class="ol-titik2">:</label>
                                            <input type="text" name="duration" class="form-control duration-new" v-model="newDuration[0]" @keypress="isNumber($event)">
                                            <div class="input-group">
                                                <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                <input type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model="newDurationPrice[0]">
                                                <label class="permonth">/month</label>
                                            </div>
                                        </div>
                                        <div class="one-line mt-3">
                                            <label class="ol-label-deposit"> Deposit </label>
                                            <label class="ol-titik2">:</label>
                                            <div class="input-group">
                                                <span class="input-group-addon-duration"> <label class="label-addon-rp">Rp</label></span>
                                                <input type="text" class="form-control deposit_price" name="price" @keypress="isNumber($event)" v-model="depositPrice[0]">
                                            </div>
                                        </div>
                                        <div style="display: inline;">
                                           <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Insurance </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <span class="input-group-addon-duration"> <label class="label-addon-rp">Rp</label></span>
                                                    <input  type="text" class="form-control deposit_price" name="price" @keypress="isNumber($event)" v-model="insurancePrice[0]">
                                                </div>
                                            </div> 
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Status </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <multiselect v-model="statusProduct[0]" :options="productStatus" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Status" class="status-product" track-by="statusName"></multiselect>
                                                </div>
                                            </div>
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Condition </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <multiselect v-model="conditionProduct[0]" :options="productCondition" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Status" class="status-product" track-by="statusName" @input="updateDuration('condition',0)"></multiselect>
                                                </div>
                                            </div>
                                            <hr>
                                        </div>
                                        <div v-for="(input, index) in tenor" :key="`tenor-${index}`">
                                            <div class="one-line mt-3">
                                                <label class="ol-label-dur">Duration (Month)</label>
                                                <label class="ol-titik2">:</label>
                                                <multiselect v-model="addDuration[index+1]" :options="productDuration[index+1]" label="tenorMonths" :allow-empty="false" :select-label="'Month'" :deselect-label="'Month'" placeholder="Duration" class="duration" track-by="tenorMonths" @input="updateDuration('duration',index+1)"></multiselect>
                                                <div class="input-group">
                                                    <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                    <input  type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model="durationPrice[index+1]" v-if="addDuration[index+1].tenorMonths != 'Other'">
                                                    <input  type="text" class="form-control price" name="price" @keypress="isNumber($event)" disabled="" v-model="durationPrice[index+1]" v-else>
                                                    <label class="permonth">/month</label>
                                                </div>
                                            </div>
                                            <div class="one-line mt-3" v-if="addDuration[index+1].tenorMonths == 'Other'">
                                                <label class="ol-label-dur-new"> New Duration </label>
                                                <label class="ol-titik2">:</label>
                                                <input type="text" name="duration" class="form-control duration-new" v-model="newDuration[index+1]" @keypress="isNumber($event)">
                                                <div class="input-group">
                                                    <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                    <input  type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model="newDurationPrice[index+1]">
                                                    <label class="permonth">/month</label>
                                                </div>
                                            </div>
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Deposit </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <span class="input-group-addon-duration"> <label class="label-addon-rp">Rp</label></span>
                                                    <input  type="text" class="form-control deposit_price" name="price" @keypress="isNumber($event)" v-model="depositPrice[index+1]">
                                                </div>
                                            </div>
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Insurance </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <span class="input-group-addon-duration"> <label class="label-addon-rp">Rp</label></span>
                                                    <input  type="text" class="form-control deposit_price" name="price" @keypress="isNumber($event)" v-model="insurancePrice[index+1]">
                                                </div>
                                            </div>
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Status </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <multiselect v-model="statusProduct[index+1]" :options="productStatus" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Status" class="status-product" track-by="statusName"></multiselect>
                                                </div>
                                            </div>
                                            <div class="one-line mt-3">
                                                <label class="ol-label-deposit"> Condition </label>
                                                <label class="ol-titik2">:</label>
                                                <div class="input-group">
                                                    <multiselect v-model="conditionProduct[index+1]" :options="productCondition" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Status" class="status-product" track-by="statusName" @input="updateDuration('condition',index+1)"></multiselect>
                                                </div>
                                            </div>
                                            <hr>
                                        </div>
                                        <div id="wrapperr" class="mt-4">
                                            <div id="c1">
                                            </div>
                                            <div id="c2">
                                                <button class="btn btn-danger btn-sm" @click="toProductCatalogPage"> Cancel </button>
                                                <button class="btn btn-success btn-sm" @click="validationField('SaveDraft')"> Save Draft </button>
                                                <button class="btn btn-primary btn-sm" @click="validationField('SavePublish')"> Save & Publish </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- Modal Save-->
            <div class="modal fade" id="modalSaveDraft" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save product {{ addModel }} ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitEditProduct('draft')">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <!-- mudalSavePublish -->
            <div class="modal fade" id="modalSavePublish" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save & Publish Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save & publish product {{ addModel }} ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitEditProduct('publish')">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
    name: 'ProductDetailPage',
    components: {
        SideBar,
        Multiselect
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
            dataLog: [],
            logProduct:'',
            imgFil: '',
            admin: "",
            permission: [],
            viewDashboard: false,
            viewOrder: false,
            viewReturn: false,
            viewProduct: false,
            viewPairing: false,
            viewReconcile: false,
            viewResolution: false,
            viewLessor: false,
            viewLessee: false,
            viewEmployee: false,
            editOrder: false,
            editReturn: false,
            editProduct: false,
            editPairing: false,
            editReconcile: false,
            editResolution: false,
            editLessor: false,
            editLessee: false,
            editEmployee: false,
            loadingButtonProcess: false,
            dataOrder: [],
            totalPage: 0,
            totalData: 0,
            currentPage: 1,
            orderId: "",
            companyName: "",
            statusOrder: "",
            productCategory: [],
            productType: [],
            productBrand: [],
            addCategory: [],
            productDuration: [[]],
            productDisplayType: ['LCD', 'LED'],
            productVGA: ['Tersedia', 'Tidak Ada'],
            productDVID: ['Tersedia', 'Tidak Ada'],
            productHDMI: ['Tersedia', 'Tidak Ada'],
            addType: [],
            addBrand: '',
            addModel: '',
            addScreen: '',
            addProcessor: '',
            addRam: '',
            addStorage: [],
            addStorageSmartphone: [],
            addVGA: '',
            addDisplaySize: '',
            addDisplayType: '',
            addPortVga: '',
            addPortDvid: '',
            addPortHdmi: '',
            addColorTech: '',
            AddFeature: '',
            addSpecifications: '',
            addDescription: '',
            addSumInsured:0,
            addYear:0,
            pricingId: [],
            addDuration: [''],
            newDuration: [''],
            durationPrice: [''],
            newDurationPrice: [''],
            depositPrice: [''],
            insurancePrice: [''],
            addPhoto: [],
            imgFile: '',
            imgFileName: '',
            imgBase64: '',
            imgUrl: '',
            newBrand: '',
            storageType: 'SSD',
            storageTypeSmartphone: 'EMMC',
            mainCamera:'',
            frontCamera:'',
            addBattery:'',
            tenor: [],
            plusIdx: 0,
            duration: [],
            newCategory: '',
            productId: "",
            conditionProduct:[{
                status:'1',
                statusName:'New'
            }],
            statusProduct:[{
                status:'1',
                statusName:'Active'
            }],
            productStatus:[{
                status:'1',
                statusName:'Active'
            },{
                status:'0',
                statusName:'Inactive'
            }],
            productCondition:[{
                status:'1',
                statusName:'New'
            },{
                status:'2',
                statusName:'Refurbished'
            }],
            durationValue:[],
            urlPhoto:[
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg",
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg",
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg",
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg",
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg",
            "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg"
            ],
            temp:[]
        }
    },
    methods: {
            toProductCatalogPage(){
              this.$router.push({path:'/product',
                    query: {
                        productType: 'All',
                        productTypeName: 'All',
                        productCategory: 'All',
                        productBrand: 'All',
                        productStatus: 'All',
                        productStatusName: 'All',
                        productName: '',
                        itemPerPage: 10,
                        page:1
                    }
                })
            },
            updateDuration(pilih,index){
                if (pilih == 'condition') {
                    for (var i = 0; i < this.conditionProduct.length; i++) {
                        if (i!=index) {
                           if (this.conditionProduct[index].status == this.conditionProduct[i].status && this.addDuration[index].tenorMonths == this.addDuration[i].tenorMonths) {
                                this.addDuration[index].tenorMonths=''
                           } 
                        } 
                    }
                }
                for (var i = 0; i < this.conditionProduct.length; i++) {
                    this.productDuration[i]=[]
                    var arrayNew = []
                    var arrayRef = []
                    for (var k = 0; k < this.temp.length; k++) {
                        arrayNew.push(this.temp[k])
                        arrayRef.push(this.temp[k])
                    }
                    for (var j = 0; j < this.conditionProduct.length; j++) {
                        if (i!=j) {
                            if (this.addDuration[j].tenorMonths != 'Other') {
                                if (this.conditionProduct[i].status == 1) {
                                    if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                        var index = arrayNew.indexOf(this.addDuration[j].tenorMonths);
                                        if (index !== -1) arrayNew.splice(index, 1);
                                    }
                                }else{
                                    if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                        var index = arrayRef.indexOf(this.addDuration[j].tenorMonths);
                                        if (index !== -1) arrayRef.splice(index, 1);
                                    }
                                }
                            }
                        }
                    }
                    if (this.conditionProduct[i].status == 1) {
                        for (var l = 0; l < arrayNew.length; l++) {
                            this.productDuration[i].push({
                                tenorMonths: arrayNew[l]
                            })
                        }
                    }else{
                        for (var l = 0; l < arrayRef.length; l++) {
                            this.productDuration[i].push({
                                tenorMonths: arrayRef[l]
                            })
                        }
                    }               
                }
            },
            addRow(x) {
                if (this.cekDuration() == 0) {
                    this.plusIdx = this.plusIdx + 1
                    this.addDuration.push({
                        tenorMonths: ''
                    })
                    this.pricingId.push('')
                    this.durationPrice.push('')
                    this.newDuration.push('')
                    this.newDurationPrice.push('')
                    this.depositPrice.push('')
                    this.insurancePrice.push('')
                    this.statusProduct.push({
                        status:'1',
                        statusName:'Active'
                    })
                    this.tenor.push('ini')
                    this.conditionProduct.push({
                        status:'1',
                        statusName:'New'
                    })
                    this.updateDuration()
                }
            },
            validationField(x) {
                if (this.addType == null || this.addType == '') {
                    swal("Sorry", "Product type must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.cekCategory() != 0) {
                    swal("Sorry", "Product Category must be fill", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == '') {
                    swal("Sorry", "Product Brand must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == 'Other') {
                    if (this.newBrand == '') {
                        swal("Sorry", "New Brand must be fill", "error", {
                            button: "Ok",
                        })
                    } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                    } else if (this.cekDuration() != 0) {
                        swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                            button: "Ok",
                        })
                    } else {
                        this.openModal(x)
                    }
                } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                } else if (this.cekDuration() != 0) {
                    swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                        button: "Ok",
                    })
                } else {
                    this.openModal(x)
                }
            },
            cekCategory: function() {
                var kosong = 0
                if (this.addCategory.productCategory == '') {
                    kosong = kosong + 1
                } else if (this.addCategory.productCategory == 'Other') {
                    if (this.newCategory == '') {
                        kosong = kosong + 1
                    }
                }
                return kosong
            },
            cekDuration: function() {
                var kosong = 0
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i].tenorMonths != 'Other' && (this.addDuration[i].tenorMonths === '' || this.durationPrice[i] === '' || this.durationPrice[i] === '0' || this.depositPrice[i] === '' || this.insurancePrice[i] === '')) {
                        kosong = kosong + 1
                    } else if (this.addDuration[i].tenorMonths == 'Other') {
                        if (this.newDuration[i] == '' || this.newDuration[i] == '0' || this.newDurationPrice[i] == '' || this.newDurationPrice[i] == '0' || this.depositPrice[i] == '' || this.insurancePrice[i] == '') {
                            kosong = kosong + 1
                        }
                    }
                }
                return kosong
            },
            cekBottomofBrand: function(type) {
                var salah = 0
                if (type == 1 || type == 2) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '') {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '') {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.storageType == 'HDD+SSD') {
                        if (this.addStorage[0] == '' || this.addStorage[0] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addStorage[1] == '' || this.addStorage[1] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addVGA == '') {
                            swal("Sorry", "Product VGA must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        } else if (this.cekFoto() == 6) {
                            swal("Sorry", "Product Foto minimum 1", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }
                    } else if (this.addStorage == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addVGA == '') {
                        swal("Sorry", "Product VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }else if (type == 5 || type == 6) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '') {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '') {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addStorageSmartphone == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addBattery == '') {
                        swal("Sorry", "Product Battery must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.AddFeature == '') {
                        swal("Sorry", "Product Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 3) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplaySize == '') {
                        swal("Sorry", "Display Size must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplayType == '') {
                        swal("Sorry", "Display Type must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortVga == '') {
                        swal("Sorry", "Port VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortDvid == '') {
                        swal("Sorry", "Port DVI-D must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortHdmi == '') {
                        swal("Sorry", "Port HDMI must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 4) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addColorTech == '') {
                        swal("Sorry", "Color Technology must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.AddFeature == '') {
                        swal("Sorry", "Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '' && this.addType.productType < 7) {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.addSpecifications == '' && this.addType.productType > 6) {
                        swal("Sorry", "Product specifications must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }
                return salah
            },
            cekFoto: function() {
                var kosong = 6
                for (var i = 0; i < 6; i++) {
                    if (this.addPhoto[i].imgFileName != '') {
                        kosong = kosong - 1
                    }
                }
                return kosong
            },
            submitEditProduct(x) {
                var self = this
                this.loadingButtonProcess = true
                if (this.addBrand == 'Other') {
                    this.addBrand = this.newBrand
                }
                if (this.addCategory.productCategory == 'Other') {
                    this.addCategory.productCategory = this.newCategory
                }
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i].tenorMonths == 'Other') {
                        this.durationValue[i] = this.newDuration[i]
                        this.durationPrice[i] = this.newDurationPrice[i]
                    } else {
                        this.durationValue[i] = this.addDuration[i].tenorMonths
                    }
                }
                if (this.addType.productType == 1 || this.addType.productType == 2) {
                    var storage
                    if (this.storageType == 'HDD+SSD') {
                        storage = this.addStorage[0] +'GB HDD , ' + this.addStorage[1] +'GB SSD'
                    }else{
                        storage = this.addStorage[0] + 'GB ' + this.storageType
                    }
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        screen: this.addScreen.toString().replace(this.spaceRegex, ' '),
                        processor: this.addProcessor !== null ? this.addProcessor.replace(this.spaceRegex, ' ') : this.addProcessor,
                        ram: this.addRam.toString().replace(this.spaceRegex, ' '),
                        storage: storage,
                        vga: this.addVGA !== null ? this.addVGA.replace(this.spaceRegex, ' ') : this.addVGA
                    }
                    this.duration = []
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            pricingId: this.pricingId[i],
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            status: this.statusProduct[i].status,
                            condition: this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.EDIT_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            sumInsured: this.addSumInsured,
                            year: this.addYear,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x,
                            productId: this.productId
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog()
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 3) {
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        displaySize: this.addDisplaySize.toString().replace(this.spaceRegex, ' '),
                        displayType: this.addDisplayType !== null ? this.addDisplayType.replace(this.spaceRegex, ' ') : this.addDisplayType,
                        portVga: this.addPortVga !== null ? this.addPortVga.replace(this.spaceRegex, ' ') : this.addPortVga,
                        portDvid: this.addPortDvid !== null ? this.addPortDvid.replace(this.spaceRegex, ' ') : this.addPortDvid,
                        portHdmi: this.addPortHdmi !== null ? this.addPortHdmi.replace(this.spaceRegex, ' ') : this.addPortHdmi
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            pricingId: this.pricingId[i],
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            status: this.statusProduct[i].status,
                            condition: this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.EDIT_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            sumInsured: this.addSumInsured,
                            year: this.addYear,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x,
                            productId: this.productId
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog()
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 4) {
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        colorTech: this.addColorTech !== null ? this.addColorTech.replace(this.spaceRegex, ' ') : this.addColorTech,
                        feature: this.AddFeature !== null ? this.AddFeature.replace(this.spaceRegex, ' ') : this.AddFeature
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            pricingId: this.pricingId[i],
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            status: this.statusProduct[i].status,
                            condition: this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.EDIT_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            sumInsured: this.addSumInsured,
                            year: this.addYear,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x,
                            productId: this.productId
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog()
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 5 || this.addType.productType == 6) {
                    var storage = this.addStorageSmartphone[0] + 'GB '
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        screen: this.addScreen.toString().replace(this.spaceRegex, ' '),
                        processor: this.addProcessor !== null ? this.addProcessor.replace(this.spaceRegex, ' ') : this.addProcessor,
                        ram: this.addRam.toString().replace(this.spaceRegex, ' '),
                        storage: storage,
                        mainCamera: this.mainCamera !== null ? this.mainCamera.replace(this.spaceRegex, ' ') : this.mainCamera,
                        frontCamera: this.frontCamera !== null ? this.frontCamera.replace(this.spaceRegex, ' ') : this.frontCamera,
                        battery : this.addBattery !== null ? this.addBattery.replace(this.spaceRegex, ' ') : this.addBattery,
                        feature : this.AddFeature !== null ? this.AddFeature.replace(this.spaceRegex, ' ') : this.AddFeature
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            pricingId: this.pricingId[i],
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            status: this.statusProduct[i].status,
                            condition: this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.EDIT_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            sumInsured: this.addSumInsured,
                            year: this.addYear,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x,
                            productId: this.productId
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }else {
                    var details={}
                    if (this.addType.productType < 7){
                        details = {
                            brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                            model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                            screen: this.addScreen.toString().replace(this.spaceRegex, ' ')
                        }
                    }else{
                        details = {
                            brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                            model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                            specifications: this.addSpecifications
                        }
                    }
                    
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            pricingId: this.pricingId[i],
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            status: this.statusProduct[i].status,
                            condition: this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.EDIT_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            sumInsured: this.addSumInsured,
                            year: this.addYear,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x,
                            productId: this.productId
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }
            },
            openModal(x) {
                $("#modal" + x).modal('show')
            },
            toPage(e) {
                this.$router.push(e)
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
            cekLogin() {
                if (localStorage.getItem('jwt') == null) {
                    this.$router.push('/')
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true
                    }
                    if (this.permission[i] == '3.1') {
                        this.viewReturn = true
                    }
                    if (this.permission[i] == '3.2') {
                        this.editReturn = true
                    }
                    if (this.permission[i] == '4.1') {
                        this.viewProduct = true
                    }
                    if (this.permission[i] == '4.2') {
                        this.editProduct = true
                    }
                    if (this.permission[i] == '5.1') {
                        this.viewPairing = true
                    }
                    if (this.permission[i] == '5.2') {
                        this.editPairing = true
                    }
                    if (this.permission[i] == '6') {
                        this.viewReconcile = true
                    }
                    if (this.permission[i] == '7.1') {
                        this.viewResolution = true
                    }
                    if (this.permission[i] == '7.2') {
                        this.editResolution = true
                    }
                    if (this.permission[i] == '8.1') {
                        this.viewLessor = true
                    }
                    if (this.permission[i] == '8.2') {
                        this.editLessor = true
                    }
                    if (this.permission[i] == '9.1') {
                        this.viewLessee = true
                    }
                    if (this.permission[i] == '9.2') {
                        this.editLessee = true
                    }
                    if (this.permission[i] == '10') {
                        this.viewEmployee = true
                    }
                }
                if (this.viewProduct == false) {
                    this.$router.push('/')
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            toDetail(id) {
                this.$router.push('/order/detail/' + id)
            },
            onFilePicked(e, index) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.imgFileName = files[0].name
                    if (this.imgFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imgUrl = fr.result
                        this.imgFile = files[0] // this is an image file that can be sent to server...
                        this.imgBase64 = fr.result.split("base64,")[1]
                        if (this.imgFileName.toLowerCase().includes(".png")) {
                            if (this.imgFile.size >= 2000000) {
                                this.imgFileName = ''
                                this.imgFile = ''
                                this.imgUrl = ''
                                swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                                        buttons: {
                                            agree: "OK",
                                        },
                                    })
                                    .then((value) => {
                                        // this.pickFile()
                                    });
                            } else {
                                var fuData = document.getElementById('file_img_' + index);
                                var FileUploadPath = fuData.value;
                                var reader = new FileReader();
                                reader.onload = function(e) {
                                    $('#show_img_' + index).attr('src', e.target.result);
                                }
                                reader.readAsDataURL(fuData.files[0]);
                                this.addPhoto[index - 1] = {
                                    imgId: this.addPhoto[index - 1].imgId,
                                    imgFileName: this.imgFileName,
                                    imgBase64: this.imgBase64
                                }
                            }
                        } else {
                            alert("Photo only allows file types of PNG. ");
                            document.getElementById("file_img_" + index).value = "";
                            document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
                        }
                    })
                } else {
                    this.imgFileName = ''
                    this.imgFile = ''
                    this.imgUrl = ''
                }
            },
            removeImage(index) {
                this.addPhoto[index - 1] = {
                    imgFileName: '',
                    imgBase64: '',
                    imgId: this.addPhoto[index - 1].imgId
                }
                document.getElementById("file_img_" + index).value = "";
                document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            getData() {
                this.loadingTable = true
                this.productId = this.$route.params.productId
                this.$http.post(process.env.GET_DETAIL_PRODUCT, {
                        productId: this.productId
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        this.addType = {
                            productType: response.data.content.detailProduct[0].productType,
                            productTypeName: response.data.content.detailProduct[0].productTypeName
                        }
                        this.addCategory = {
                            productCategory: response.data.content.detailProduct[0].productCategory
                        }
                        this.addBrand = JSON.parse(response.data.content.detailProduct[0].productDetails)["brand"]
                        this.addScreen = JSON.parse(response.data.content.detailProduct[0].productDetails)["screen"]
                        this.addDescription = response.data.content.detailProduct[0].productDescription
                        this.addSumInsured = response.data.content.detailProduct[0].sumInsured
                        this.addYear = response.data.content.detailProduct[0].year
                        this.addModel = JSON.parse(response.data.content.detailProduct[0].productDetails)["model"]
                        if (this.addType.productType == 1 || this.addType.productType == 2) {
                            this.addProcessor = JSON.parse(response.data.content.detailProduct[0].productDetails)["processor"]
                            this.addRam = JSON.parse(response.data.content.detailProduct[0].productDetails)["ram"]
                            if (JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].search('SSD') != '-1' && JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].search('HDD') != '-1') {
                                this.storageType = 'HDD+SSD'
                                this.addStorage[0] = JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].substring(0,JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].search('HDD')).replace(/ /gi, '').replace('GB', '')
                                this.addStorage[1] = JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].substring(JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].search('HDD'),JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].search('SSD')).replace('GB', '').replace(/ /gi, '').replace('HDD', '').replace(',', '')
                            }else{
                                this.addStorage[0] = JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].replace(/ /gi, '').replace('GB', '').replace('SSD', '').replace('HDD', '')
                                this.storageType = JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].substr(-3)
                            }
                            this.addVGA = JSON.parse(response.data.content.detailProduct[0].productDetails)["vga"]
                        } else if (this.addType.productType == 3) {
                            this.addDisplaySize = JSON.parse(response.data.content.detailProduct[0].productDetails)["displaySize"]
                            this.addDisplayType = JSON.parse(response.data.content.detailProduct[0].productDetails)["displayType"]
                            this.addPortVga = JSON.parse(response.data.content.detailProduct[0].productDetails)["portVga"]
                            this.addPortDvid = JSON.parse(response.data.content.detailProduct[0].productDetails)["portDvid"]
                            this.addPortHdmi = JSON.parse(response.data.content.detailProduct[0].productDetails)["portHdmi"]
                        } else if (this.addType.productType == 4) {
                            this.AddFeature = JSON.parse(response.data.content.detailProduct[0].productDetails)["feature"]
                            this.addColorTech = JSON.parse(response.data.content.detailProduct[0].productDetails)["colorTech"]
                        }else if (this.addType.productType == 5 || this.addType.productType == 6) {
                            this.addProcessor = JSON.parse(response.data.content.detailProduct[0].productDetails)["processor"]
                            this.addRam = JSON.parse(response.data.content.detailProduct[0].productDetails)["ram"]
                            this.addStorageSmartphone[0] = JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].replace(' ', '').replace('GB', '').replace('EMMC', '').replace('UFS', '')
                            if (JSON.parse(response.data.content.detailProduct[0].productDetails)["storage"].substr(-3) == 'UFS') {
                                this.storageTypeSmartphone = 'UFS'
                            }else{
                                this.storageTypeSmartphone = 'EMMC'
                            }
                            
                            this.mainCamera = JSON.parse(response.data.content.detailProduct[0].productDetails)["mainCamera"]
                            this.frontCamera = JSON.parse(response.data.content.detailProduct[0].productDetails)["frontCamera"]
                            this.addBattery = JSON.parse(response.data.content.detailProduct[0].productDetails)["battery"]
                            this.AddFeature = JSON.parse(response.data.content.detailProduct[0].productDetails)["feature"]
                        }else{
                            this.addSpecifications = JSON.parse(response.data.content.detailProduct[0].productDetails)["specifications"]
                        }

                        for (var j = 0; j < response.data.content.productPhoto.length; j++) {
                            this.addPhoto[j] = {
                                imgFileName: response.data.content.productPhoto[j].imgName,
                                imgBase64: '',
                                imgId: response.data.content.productPhoto[j].photoId,
                            }
                            this.urlPhoto[j] = response.data.content.productPhoto[j].imgUrl;
                        }
                        this.pricingId = []
                        this.addDuration = []
                        this.durationPrice = []
                        this.insurancePrice = []
                        this.statusProduct = [{
                            status:'1',
                            statusName:'Active'
                        }]
                        this.plusIdx = 0
                        this.newDuration = []
                        this.depositPrice = []
                        this.newDurationPrice = []
                        this.tenor = []
                        for (var i = 0; i < response.data.content.productDuration.length; i++) {
                            if (i == 0) {
                                this.pricingId[i] = response.data.content.productDuration[i].pricingId
                                this.addDuration[i] = {
                                    tenorMonths: response.data.content.productDuration[i].tenorMonths
                                }
                                this.durationPrice[i] = response.data.content.productDuration[i].tenorPrice
                                this.depositPrice[i] = response.data.content.productDuration[i].depositPrice
                                this.insurancePrice[i] = response.data.content.productDuration[i].insurancePrice
                                this.statusProduct[i].status = response.data.content.productDuration[i].statusProduct
                                this.conditionProduct[i].status = response.data.content.productDuration[i].condition
                                if (response.data.content.productDuration[i].condition == 1) {
                                    this.conditionProduct[i].statusName = 'New'
                                }else{   
                                    this.conditionProduct[i].statusName = 'Refurbished'
                                }
                                if (response.data.content.productDuration[i].statusProduct == 1) {
                                    this.statusProduct[i].statusName = 'Active'
                                }else{
                                    this.statusProduct[i].statusName = 'Inactive'
                                }
                            } else {
                                this.plusIdx = this.plusIdx + 1
                                this.pricingId.push(response.data.content.productDuration[i].pricingId)
                                this.addDuration.push({
                                    tenorMonths: response.data.content.productDuration[i].tenorMonths
                                })

                                this.durationPrice.push(response.data.content.productDuration[i].tenorPrice)
                                this.newDuration.push('')
                                this.newDurationPrice.push('')
                                this.depositPrice.push(response.data.content.productDuration[i].depositPrice)
                                this.insurancePrice.push(response.data.content.productDuration[i].insurancePrice)
                                var statusName
                                if (response.data.content.productDuration[i].statusProduct == 1) {
                                    statusName = 'Active'
                                }else{
                                    statusName = 'Inactive'
                                }
                                this.statusProduct.push({
                                    status:response.data.content.productDuration[i].statusProduct,
                                    statusName: statusName
                                })
                                let conditionName
                                if (response.data.content.productDuration[i].condition == 1) {
                                    conditionName = 'New'
                                }else{   
                                    conditionName = 'Refurbished'
                                }
                                this.conditionProduct.push({
                                    status:response.data.content.productDuration[i].condition,
                                    statusName:conditionName
                                })
                                this.tenor.push('ini')
                                this.productDuration.push([])
                            }
                        }
                        this.loadingTable = false
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                this.$http.get(process.env.GET_CATEGORY_ADD, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.productType = response.data.content.productType
                            this.productCategory = response.data.content.productCategory
                            this.productCategory.push({
                                productCategory: 'Other'
                            })

                            this.productBrand = Object.values(response.data.content.productBrand)
                            for (var i = 0; i < response.data.content.productDuration.length; i++) {
                                this.productDuration[0].push({
                                    tenorMonths: response.data.content.productDuration[i]
                                })
                                this.temp.push(response.data.content.productDuration[i])
                            }
                            this.productBrand.push('Other')
                            this.productDuration[0].push({
                                tenorMonths: 'Other'
                            })
                            this.temp.push('Other')
                            this.updateDuration('duration',0)
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            connectLogProduct:function(){
                var productId = this.productId
                this.$http.get(process.env.LOG_URL+"/product/"+productId,{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        this.dataLog = response.data.content
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            },
            getLogProduct(data){
                this.logProduct = data
            },
            sendLog(){
                var today = new Date();
                var month = today.getMonth()+1
                if (month < 10) {
                    month = '0'+month
                }
                var dateDay = today.getDate()
                if (dateDay < 10) {
                    dateDay = '0'+dateDay
                }
                var hours = today.getHours()
                if (hours < 10) {
                    hours = '0'+hours
                }
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = '0'+minutes
                }
                var second = today.getSeconds()
                if (second < 10) {
                    second = '0'+second
                }
                var date = today.getFullYear()+'-'+month+'-'+dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date+' '+time;
                var admin = this.admin
                var command = 'add-logs'
                let productName = ''
                if (this.addBrand == 'Other') {
                    productName  = this.newBrand+' '+this.addModel
                }else{
                    productName  = this.addBrand+' '+this.addModel
                }
                this.$http.post(process.env.LOG_URL+"/product/"+this.productId,{
                    codeLogs: 28,
                    params: [productName.replace(this.spaceRegex, ' ')],
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    this.connectLogProduct()
                })
                .catch(error => {
                    console.log(error)
                })
            }
    },
    created() {
        for (var i = 0; i < 6; i++) {
            this.addPhoto.push({
                imgFileName: '',
                imgBase64: '',
                imgId: '',
            })
        }
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
        this.connectLogProduct()
    }
} 
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fixed_header{
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody{
  display:block;
  overflow:auto;
  height:200px;
  width:100%;
}

.fixed_header tbody.full-width tr td{
  width:1578px;
}

.fixed_header thead tr{
  display:block;
}

.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}
    .deposit_price{
      max-width: 120px;
    }
    .input-group-addon-duration {
      padding: 7px 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      color: #555;
      text-align: center;
      background-color: #eee;
      border: 1px solid #ccc;
      border-radius: 4px 0px 0px 4px;
      border-right: none;
      margin: 0px 0px 0px 5px;
      height: fit-content;
    }
    .one-line .ol-label-deposit{
      width: 195px;
      margin: 6px 0px;
    }

    .one-line .ol-label-insurance{
      width: 428px;
      margin: 6px 0px;
    }
  .duration{
    width: 240px;
    margin-left: 5px;
  }
  .status-product{
    width: 160px;
    margin-left: 5px;
  }
  .duration-new{
    width: 165px;
    margin-left: 5px;
  }

    #wrapperr{
      overflow:auto;
      margin: 5px 3px;
    }

    #c1{
     float:left;
    }

    #c2{
      float: right;  
    }
    .input-group-addon {
      padding: 7px 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      color: #555;
      text-align: center;
      background-color: #eee;
      border: 1px solid #ccc;
      border-radius: 4px 0px 0px 4px;
      border-right: none;
      margin: 0px 0px 0px 10px;
      height: fit-content;
    }

    .price{
      max-width: 150px;
    }

    .label-addon-rp{
      margin: 5px 0px;
    }

    .permonth{ 
      margin: 6px 0px 5px 5px;
    }

    .one-file{
      margin: 0px 10px;
    }

    .one-line-file{
      display: grid;
    }

    .img-responsive{
      width: 270px;
      height: auto;
    }

    .storage-type{
      max-width: 100px;
    }

    .one-line{
      display: flex;
      margin: 5px 0px;
    }

    .one-line .ol-label{
      width: 188px;
      margin: 5px 0px;
    }

    .one-line .ol-label.storage{
      width: 215px;
      margin: 6px 0px;
    }

    .one-line .ol-label-photo{
      width: 155px;
      margin: 6px 0px;
    }

    .one-line .ol-label-dur{
      width: 240px;
      margin: 6px 0px;
    }

    .one-line .ol-label-dur-new{
      width: 240px;
      margin: 6px 0px;
    }

    .one-line .ol-label-reason{
      width: 88px;
      margin: 6px 0px;
    }

    .one-line .ol-titik2{
      width: 15px;
      margin: 6px 0px;
    }

    .one-line .ol-value{
      width: 100%;
      margin: 6px 0px;
    }

    .pagination{
      padding: 0px 0;
    }

    .pagination ul{
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    .pagination a{
      display: inline-block;
      padding: 1px 6px;
      color: #222;
    }

    .p8 a{
      background-color: #2797FB;
      /*margin: auto 5px;*/
      color: #fff;
      /*font-weight: bold;*/
      border: 1px solid #2797FB;
    }

    .p8 a:hover{
      text-decoration: none;
    }
    .p8 a.page:hover{
      text-decoration: none;
      color: #fff;
    }

    .p8 .is-active{
      background-color: #fff;
      color: #2797FB;
    }

    .alignleft {
      float: left;
    }
    .alignright {
      float: right;
    }

    .pagg{
      display: inline-flex;
      overflow:auto;
    }

    .total-data{
      padding: 11px 0px;
      font-size: 14px;
      color: #343A40;
    }
    #wrapperr{
      overflow:auto;
      margin: 5px 3px;
    }

    #c1{
     float:left;
   }

   #c2{
    float: right;  
  }

  .search-table{
    padding-bottom: 7px;
    margin-top: -5px;
    margin-left: -15px;
  }
  .active{
    color: #2797FB;
  }
  .right-dropdown{
    margin-left: 7px;
  }
  .account-div{
    margin: 2px 2px;
  }
  .right-arrow{
    margin-left: auto;
  }
  .brand-logo{
    width: 120px;
  }
  .menu-title{
    margin-left: 1.125rem;
  }
  .menu-title-order{
    margin-left: 1.95rem;
  }
  .menu-title-payment{
    margin-left: 1.525rem;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    /*width: 200px;*/
    /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
    display: block;
    color: #000;
    padding: 8px 63px;
    text-decoration: none;
  }

  li a.active {
    background-color: #4CAF50;
    color: white;
  }

  li a:hover:not(.active) {
    background-color: #2797FB;
    color: white;
  }
  .nav-side-menu {
    overflow: auto;
    font-family: verdana;
    font-size: 12px;
    font-weight: 200;
    background-color: #2e353d;
    position: fixed;
    top: 0px;
    width: 300px;
    height: 100%;
    color: #e1ffff;
  }
  .nav-side-menu .brand {
    background-color: #23282e;
    line-height: 50px;
    display: block;
    text-align: center;
    font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
    display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
    list-style: none;
    padding: 0px;
    margin: 0px;
    line-height: 35px;
    cursor: pointer;
  }
  .nav-side-menu ul :not(collapsed) .arrow:before,
  .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Product/ProductDetailPage.vue